import { render } from "./QuoteDetails.vue?vue&type=template&id=26a59a57&scoped=true&ts=true"
import script from "./QuoteDetails.vue?vue&type=script&lang=ts"
export * from "./QuoteDetails.vue?vue&type=script&lang=ts"

import "./QuoteDetails.vue?vue&type=style&index=0&id=26a59a57&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26a59a57"]])

export default __exports__